import { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { connect } from 'react-redux';
import { localStorage } from 'dibs-browser-storage';

// components
import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button';
import ArrowRight from 'dibs-icons/exports/ArrowRight';
import makeOfferLauncher from 'dibs-buyer-layout/exports/makeOfferLauncher';

// mutations
import { SharedModifyPortfolioItems } from '../../mutations/FindingSharedModifyPortfolioItems';

// styles
import styles from './PdpSharedButtons.scss';

// helpers
import get from 'lodash.get';
import { trackMakeOfferClick, trackMakeOfferFromEmail } from '../tracking/actionButtonsTracking';
import { setCartItems } from '../../actions/sharedMobileActions';
import { getQueryParam } from '../../utils/uriUtils';

const OPEN_OFFER_MODAL = 'openOfferModal';

// constants
const makeOfferCTA = showArrow => (
    <div className={styles.makeOfferButton}>
        <FormattedMessage
            id="PdpSharedMakeOfferButton.makeOfferCta"
            defaultMessage="Make An Offer"
        />
        {showArrow && <ArrowRight className={styles.arrowSVG} />}
    </div>
);

export class PdpSharedMakeOfferButtonComponent extends Component {
    constructor(props) {
        super(props);

        this.openModal = this.openModal.bind(this);
    }

    componentDidMount() {
        const queryParams = get(global, 'location.search');
        const modalParam = getQueryParam(queryParams, 'modal');
        const templateParam = getQueryParam(queryParams, 'utm_campaign');
        const openModalFromRefresh = localStorage.getItem(OPEN_OFFER_MODAL);

        if (modalParam === 'offer' || openModalFromRefresh) {
            localStorage.deleteItem(OPEN_OFFER_MODAL);
            this.openModal();

            if (templateParam) {
                trackMakeOfferFromEmail({
                    template: templateParam,
                    item: this.props.item,
                });
            }
        }
    }

    openModal(event) {
        const {
            dispatch,
            userId,
            itemId,
            selectedSkuId,
            item,
            relay,
            quantitySelected,
            currency,
            hasPrivateOffer,
            shouldLaunchContactDealer,
        } = this.props;
        trackMakeOfferClick(
            {
                ...item,
                pdpTrackingVpvParams: item.makeOfferVpvParams,
                hasPrivateOffer,
            },
            event
        );

        if (!userId) {
            // If no user, store item - it can be ADDed to cart when user logs in later
            dispatch(setCartItems(itemId));
        } else {
            // ADD item to user's cart
            this.addToCartMutation(itemId);
        }

        makeOfferLauncher({
            itemId,
            selectedSkuId,
            currency,
            environment: relay.environment,
            quantitySelected,
            shouldLaunchContactDealer,
            launchOrigin: 'pdp-shared',
        });
    }

    addToCartMutation(itemId) {
        const { relay, userId } = this.props;
        SharedModifyPortfolioItems.commit(relay.environment, {
            action: 'ADD',
            itemId,
            portfolioType: 'CART',
            userId,
        });
    }

    render() {
        const { size, showArrow, item } = this.props;
        const isPrivateVisibilityType = get(item, 'isPrivateVisibilityType');

        return (
            <Button
                type={isPrivateVisibilityType ? 'secondaryAlt' : 'secondary'}
                className={`${styles.button} ${styles.fullWidth}`}
                dataTn="item-actions-make-offer"
                onClick={this.openModal}
                size={size}
            >
                {makeOfferCTA(size !== 'small' && showArrow)}
            </Button>
        );
    }
}

PdpSharedMakeOfferButtonComponent.defaultProps = {
    size: 'large',
    showArrow: true,
    hasPrivateOffer: false,
    shouldLaunchContactDealer: true,
};

PdpSharedMakeOfferButtonComponent.propTypes = {
    userId: PropTypes.string,
    itemId: PropTypes.string.isRequired,
    selectedSkuId: PropTypes.string,
    item: PropTypes.object.isRequired,
    dispatch: PropTypes.func,
    currency: PropTypes.string.isRequired,
    relay: PropTypes.object,
    user: PropTypes.object,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    quantitySelected: PropTypes.string,
    showArrow: PropTypes.bool.isRequired,
    hasPrivateOffer: PropTypes.bool,
    shouldLaunchContactDealer: PropTypes.bool,
};

PdpSharedMakeOfferButtonComponent = connect()(PdpSharedMakeOfferButtonComponent);

export const PdpSharedMakeOfferButton = createFragmentContainer(PdpSharedMakeOfferButtonComponent, {
    item: graphql`
        fragment PdpSharedMakeOfferButton_item on Item {
            ...SharedContactDealerWrapper_item
            serviceId
            makeOfferVpvParams: pdpTrackingVpvParams(
                userId: $userId
                excludedPurchaseStatuses: [RET, CUST]
            ) @include(if: $isClient)
            contemporaryTrackingString
            title
            seller {
                serviceId
            }
            pricing {
                totalAmount {
                    amount
                }
            }
            categoryCode
            browseUrl
            isPrivateVisibilityType
        }
    `,
    user: graphql`
        fragment PdpSharedMakeOfferButton_user on User {
            ...SharedContactDealerWrapper_user
            profile {
                currency
            }
        }
    `,
});
